import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=3ea8e0b0&scoped=true&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"
import style0 from "./Popups.vue?vue&type=style&index=0&id=3ea8e0b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8e0b0",
  null
  
)

export default component.exports